import { createSlice, current, PayloadAction } from '@reduxjs/toolkit';
import { Area, Port, SimpleRoute, TerminalMapData, ViewportData } from 'ais-facade-api/api';
import { Filters } from 'app/pages/VesselsPage/VesselsPage';
import { Filters as AtonsFilters } from 'app/pages/AtonsPage/AtonsPage';
import { Filters as PortsFilters } from 'app/pages/PortsPage/PortsPage';
const initialState = {
  facadeResult: {},
  vesselsOnMap: [] as ViewportData[],
  portsOnMap: [] as Port[],
  anchoragesOnMap: [] as Area[],
  terminalsOnMap: [] as TerminalMapData[],
  atonsOnMap: [] as ViewportData[],
  vesselsCatalogFilter: null as Filters | null,
  atonsCatalogFilter: null as AtonsFilters | null,
  portsCatalogFilter: null as PortsFilters | null,
  routeBuilded: {
    route: null as SimpleRoute | null,
    isShown: false,
  },
  anlyticsFilter: {
    period: 'WEEK',
    shipType: 'COUNT_ALL',
  },
  playbackResult: [] as any,
};

export const facadeReducer = createSlice({
  name: 'facadeSlice',
  initialState,
  reducers: {
    setFacadeResult: (state, action: PayloadAction<any>) => {
      state.facadeResult = action.payload;
    },
    setVesselsOnMap: (state, action: PayloadAction<any>) => {
      state.vesselsOnMap = action.payload;
    },
    setPortsOnMap: (state, action: PayloadAction<any>) => {
      state.portsOnMap = action.payload;
    },
    setTerminalsOnMap: (state, action: PayloadAction<any>) => {
      state.terminalsOnMap = action.payload;
    },
    setAtonsOnMap: (state, action: PayloadAction<any>) => {
      state.atonsOnMap = action.payload;
    },
    setVesselsCatalogFilter: (state, action: PayloadAction<any>) => {
      state.vesselsCatalogFilter = action.payload;
    },
    setAtonsCatalogFilter: (state, action: PayloadAction<any>) => {
      state.atonsCatalogFilter = action.payload;
    },
    setPortsCatalogFilter: (state, action: PayloadAction<any>) => {
      state.portsCatalogFilter = action.payload;
    },
    setRouteBuilded: (state, action: PayloadAction<any>) => {
      state.routeBuilded.route = action.payload;
    },
    setShowRouteBuilded: (state, action: PayloadAction<any>) => {
      state.routeBuilded.isShown = action.payload;
    },
    setAnlyticsFilter: (state, action: PayloadAction<any>) => {
      state.anlyticsFilter = action.payload;
    },
    setPlaybackResult: (state, action: PayloadAction<any>) => {
      state.playbackResult = action.payload;
    },
    setNewChunk: (state, action: PayloadAction<any>) => {
      const mmsi = action.payload?.mmsi;
      const currentState = current(state.playbackResult);

      const existedItemIndex = currentState.findIndex((el: any) => {
        const values: any = Object.values(el)?.[0];
        return values.mmsi === mmsi;
      });
      if (existedItemIndex !== -1) {
        state.playbackResult[existedItemIndex] = { [mmsi]: action.payload };
      } else {
        state.playbackResult = [...currentState, { [mmsi]: action.payload }];
      }
    },
    setAnchorageOnMap: (state, action: PayloadAction<any>) => {
      state.anchoragesOnMap = action.payload;
    },
  },
});

export const {
  setFacadeResult,
  setVesselsOnMap,
  setPortsOnMap,
  setTerminalsOnMap,
  setAtonsOnMap,
  setVesselsCatalogFilter,
  setAtonsCatalogFilter,
  setPortsCatalogFilter,
  setRouteBuilded,
  setShowRouteBuilded,
  setAnlyticsFilter,
  setPlaybackResult,
  setNewChunk,
  setAnchorageOnMap,
} = facadeReducer.actions;
export default facadeReducer.reducer;
